import * as Dialog from "../ui/dialog";
import { CheckEmailExplainerHeader } from "../molecules";
import { CheckEmailExplainerCloseButton } from "../atoms";
import { CheckEmailExplainerContent } from "../organisms";

export const CheckEmailDialog = ({
  emailAddress,
}: {
  emailAddress: string;
}) => {
  return (
    <Dialog.Root defaultOpen>
      <Dialog.Content
        className="border border-indigo-300"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <Dialog.Header className="bg-mandarin-50">
          <CheckEmailExplainerHeader />
        </Dialog.Header>
        <CheckEmailExplainerContent emailAddress={emailAddress} />
        <Dialog.Footer>
          <div className="flex justify-end w-full">
            <Dialog.Close asChild>
              <CheckEmailExplainerCloseButton />
            </Dialog.Close>
          </div>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
